import { Logger } from "../Logger";
import { all } from "ramda";
import { gatherVideoClientDataSource } from "../Globals";
import { ErrorContext } from "gather-common/dist/src/public/utils";
var Category;
(function (Category) {
    Category[Category["RecvMedia"] = 0] = "RecvMedia";
    Category[Category["SendMedia"] = 1] = "SendMedia";
    Category[Category["Signaling"] = 2] = "Signaling";
})(Category || (Category = {}));
export class MediaInterruptionMetricsCollector {
    started = false;
    sfuCollectors = new Map();
    start() {
        if (!this.started) {
            this.resetCollection();
            this.started = true;
        }
    }
    stop() {
        this.started = false;
    }
    resetCollection() {
        this.sfuCollectors.forEach((collector) => collector.resetCollection());
    }
    outputMetrics() {
        if (!this.started)
            return [];
        const metrics = [];
        for (const [sfuAddr, collector] of this.sfuCollectors) {
            collector.outputMetrics().forEach(({ name, values }) => {
                metrics.push({ name, values: { sfuAddr, ...values } });
            });
        }
        return metrics;
    }
    registerSFU(sfuAddr) {
        const sfuCollector = new SingleSFUMediaInterruptionMetricsCollector(sfuAddr);
        this.sfuCollectors.set(sfuAddr, sfuCollector);
        sfuCollector.start();
    }
    unregisterSFU(sfuAddr) {
        this.sfuCollectors.get(sfuAddr)?.stop();
        this.sfuCollectors.delete(sfuAddr);
    }
    signalingInterruptedEvent = (sfuAddr, interrupted) => {
        const collector = this.sfuCollectors.get(sfuAddr);
        collector?.handleInterruptedEvent(Category.Signaling, interrupted);
    };
    mediaInterruptedEvent = (sfuAddr, direction, interrupted) => {
        const collector = this.sfuCollectors.get(sfuAddr);
        collector?.handleInterruptedEvent(direction === "send" ? Category.SendMedia : Category.RecvMedia, interrupted);
    };
}
export class SingleSFUMediaInterruptionMetricsCollector {
    _serverAddr;
    _interrupted = [false, false, false];
    _interruptedTimestamp = [undefined, undefined, undefined];
    _interruptedCount = [0, 0, 0];
    _interruptedTotalTime = [0, 0, 0];
    constructor(sfuAddr) {
        this._serverAddr = sfuAddr;
    }
    start() {
        this.resetCollection();
    }
    stop() { }
    resetCollection() {
        const now = gatherVideoClientDataSource.performance().now();
        [Category.RecvMedia, Category.SendMedia, Category.Signaling].forEach((index) => {
            this._interruptedCount[index] = 0;
            this._interruptedTimestamp[index] = now;
            this._interruptedTotalTime[index] = 0;
        });
    }
    outputMetrics() {
        const now = gatherVideoClientDataSource.performance().now();
        const metric = {};
        metric["recvMediaInterruptedCount"] = this._interruptedCount[Category.RecvMedia] ?? 0;
        metric["recvMediaInterruptedTotalTime"] =
            (this._interruptedTotalTime[Category.RecvMedia] ?? 0) +
                (this._interrupted[Category.RecvMedia]
                    ? now - (this._interruptedTimestamp[Category.RecvMedia] ?? 0)
                    : 0);
        if (metric["recvMediaInterruptedTotalTime"] < 0) {
            Logger.error(`debug negative recvMedia interrupted total time`, new ErrorContext({
                interruptedTotalTime: this._interruptedTotalTime[Category.RecvMedia] ?? 0,
                interruptedTimestamp: this._interruptedTimestamp[Category.RecvMedia] ?? 0,
                now,
            }));
        }
        metric["sendMediaInterruptedCount"] = this._interruptedCount[Category.SendMedia] ?? 0;
        metric["sendMediaInterruptedTotalTime"] =
            (this._interruptedTotalTime[Category.SendMedia] ?? 0) +
                (this._interrupted[Category.SendMedia]
                    ? now - (this._interruptedTimestamp[Category.SendMedia] ?? 0)
                    : 0);
        if (metric["sendMediaInterruptedTotalTime"] < 0) {
            Logger.error(`debug negative sendTMedia interrupted total time`, new ErrorContext({
                interruptedTotalTime: this._interruptedTotalTime[Category.SendMedia] ?? 0,
                now,
                interruptedTimestamp: this._interruptedTimestamp[Category.SendMedia] ?? 0,
            }));
        }
        metric["signalingInterruptedCount"] = this._interruptedCount[Category.Signaling] ?? 0;
        metric["signalingInterruptedTotalTime"] =
            (this._interruptedTotalTime[Category.Signaling] ?? 0) +
                (this._interrupted[Category.Signaling]
                    ? now - (this._interruptedTimestamp[Category.Signaling] ?? 0)
                    : 0);
        if (metric["signalingInterruptedTotalTime"] < 0) {
            Logger.error(`debug negative signaling interrupted total time`, new ErrorContext({
                interruptedTotalTime: this._interruptedTotalTime[Category.Signaling] ?? 0,
                now,
                interruptedTimestamp: this._interruptedTimestamp[Category.Signaling] ?? 0,
            }));
        }
        if (all((x) => x === 0)(Object.values(metric)))
            return [];
        return [{ name: "video-client-sfu", values: metric }];
    }
    _processInterruptedEvent(category) {
        this._interruptedCount[category]++;
        this._interruptedTimestamp[category] = gatherVideoClientDataSource.performance().now();
        return;
    }
    _processResumedEvent(category) {
        this._interruptedTotalTime[category] +=
            gatherVideoClientDataSource.performance().now() - (this._interruptedTimestamp[category] ?? 0);
        if ((this._interruptedTotalTime[category] ?? 0) < 0) {
            Logger.error(`debug negative category interrupted total time`, new ErrorContext({
                category,
                now: gatherVideoClientDataSource.performance().now(),
                interruptedTimestamp: this._interruptedTimestamp[category] ?? 0,
            }));
        }
    }
    handleInterruptedEvent(category, interrupted) {
        if (this._interrupted[category] === interrupted)
            return;
        interrupted ? this._processInterruptedEvent(category) : this._processResumedEvent(category);
        this._interrupted[category] = interrupted;
    }
}
//# sourceMappingURL=MediaInterruptionMetricsCollector.js.map